import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const addBOMProduct = async (JsonObject, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/addBOMProduct`,
      JsonObject,
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const EditBOMIsActive = async (bom_id, product_id, user_id, token) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/bom/EditBOMIsActive`,
      { bom_id: bom_id, product_id: product_id },
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteBOMById = async (bom_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/DeleteBOMById`,
      { bom_id: bom_id },
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getAllBOMs = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getallboms`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getAllFinishedProducts = async (store_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getAllFinishedProducts`,
      { store_id: store_id },
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getAllRawSemiProducts = async (store_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getAllRawSemiProducts`,
      { store_id: store_id },
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getBOMsbyProduct = async (product_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getBOMsbyProduct`,
      { product_id: product_id },
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getBOMbyId = async (bom_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getBOMbyId`,
      { bom_id: bom_id },
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getBOMCompbyId = async (bom_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getBOMCompbyId`,
      { bom_id: bom_id },
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const checkBOMbyId = async (bom_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/checkBOMbyId`,
      { bom_id: bom_id },
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getCompforBOM = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getBOMsbyProduct`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getBOMsProductList = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/bom/getBOMsProductList`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
